import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideToast, selectToasts } from "../store/slices/uiSlice";

const typeStyles = {
  success: {
    backgroundColor: "#dcfce7",
    borderColor: "#16a34a",
    color: "#166534",
  },
  error: {
    backgroundColor: "#fee2e2",
    borderColor: "#dc2626",
    color: "#991b1b",
  },
  warning: {
    backgroundColor: "#fef3c7",
    borderColor: "#d97706",
    color: "#92400e",
  },
};

function ToastItem({ toast, onDismiss }) {
  useEffect(() => {
    const timeout = setTimeout(() => {
      onDismiss(toast.id);
    }, toast.duration);

    return () => clearTimeout(timeout);
  }, [toast.id, toast.duration, onDismiss]);

  const variant = typeStyles[toast.type] || typeStyles.success;

  return (
    <div
      style={{
        minWidth: 260,
        maxWidth: 380,
        padding: "12px 14px",
        borderRadius: 10,
        border: `1px solid ${variant.borderColor}`,
        backgroundColor: variant.backgroundColor,
        color: variant.color,
        fontSize: 14,
        boxShadow: "0 8px 18px rgba(0, 0, 0, 0.12)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
      }}
    >
      <span>{toast.message}</span>
      <button
        type="button"
        onClick={() => onDismiss(toast.id)}
        style={{
          border: "none",
          background: "transparent",
          color: "inherit",
          fontWeight: 700,
          cursor: "pointer",
          fontSize: 16,
          lineHeight: 1,
        }}
        aria-label="Dismiss toast"
      >
        ×
      </button>
    </div>
  );
}

function ToastContainer() {
  const dispatch = useDispatch();
  const toasts = useSelector(selectToasts);

  const handleDismiss = (id) => {
    dispatch(hideToast(id));
  };

  if (!toasts.length) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 20,
        right: 20,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={handleDismiss} />
      ))}
    </div>
  );
}

export default ToastContainer;
